
import { Component, Mixins } from "vue-property-decorator";
import { mapState } from "vuex";
import { RegisterFormDto } from "@/types/user.type";
import ValidatedFormMixin from "@/common/mixins/validated-form.mixin";

@Component({
  computed: {
    ...mapState("Auth", ["errorMessage", "user"])
  }
})
export default class Register extends Mixins(ValidatedFormMixin) {
  form: RegisterFormDto = new RegisterFormDto();
  passwordShow = false;
  confirmShow = false;
  loading = false;

  errorMessage!: string;

  viewPassword(): void {
    this.passwordShow = !this.passwordShow;
  }

  viewConfirm(): void {
    this.confirmShow = !this.confirmShow;
  }

  resetErrorMessage(): void {
    this.$store.commit("Auth/updateField", {
      path: "errorMessage",
      value: null
    });
  }

  async submit(): Promise<void> {
    await this.$validator.validateAll().then(async (isValid: boolean) => {
      if (isValid) {
        this.loading = true;
        this.resetErrorMessage();
        await this.$store.dispatch("Auth/register", this.form);
        this.loading = false;
        if (!this.errorMessage) {
          this.$router.push("/login");
        }
      }
    });
  }
}
